import { RiderTagEnum } from '../enums/rider-tag.enum';

export class RiderTag {
    public static RiderTagList: Array<any> = [
        { value: RiderTagEnum.All, name: 'All' },
        { value: RiderTagEnum.Regular, name: 'Regular' },
        { value: RiderTagEnum.CampaignDriver, name: 'Campaign Driver' },
        { value: RiderTagEnum.Xpress50, name: 'Xpress 50' },
        { value: RiderTagEnum.AssignedToBoracayCampaign, name: 'Boracay Campaign' },
        { value: RiderTagEnum.Xpress50Rider4W, name: 'Xpress 50 4W' }
    ];
}
